import { render } from "./DannRegionalCard.vue?vue&type=template&id=0add2689&scoped=true&ts=true"
import script from "./DannRegionalCard.vue?vue&type=script&lang=ts"
export * from "./DannRegionalCard.vue?vue&type=script&lang=ts"

import "./DannRegionalCard.vue?vue&type=style&index=0&id=0add2689&lang=css&scoped=true"

import exportComponent from "/codebuild/output/src1651641719/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0add2689"]])

export default __exports__